import type {ReactElement} from 'react';
import {AiWriter} from '@Components/ai-writer';
import {AiWriterType} from '@Components/ai-writer/ai-writer.types';
import {useAiVoiceWriter} from '@Components/ai-writer/adapters/use-ai-voice-writer';
import type {AiWriterPanelViewProps} from './ai-writer-panel-view.types';

export function AiWriterPanelView({onBack, onClose, onContentSelected, isOpenedInPopOver}: AiWriterPanelViewProps): ReactElement {
  const source = useAiVoiceWriter({onContentSelected});

  return <AiWriter displayType={AiWriterType.PANEL} source={source} showBackButton onBack={onBack} onClose={onClose} isOpenedInPopOver={isOpenedInPopOver} />;
}
